import React, {Component} from 'react';
import { connect } from 'react-redux';

import {ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import {grey400} from 'material-ui/styles/colors';

class ChatMessageMemberListItem extends Component{
    constructor(props) {
      super(props);
      this.state = {
        openIconMenu: false
      };

      this.onMenuItemClicked = this.onMenuItemClicked.bind(this);
    }

    onMenuItemClicked() {
      this.props.openDialog(this.props.member.userId);
      this.setState({openIconMenu: false})
    }

    render() {
      let role;
      let secondaryText = [];
      const iconButtonElement = (
        <IconButton
          tooltip="more"
          tooltipPosition="bottom-left"
        >
          <MoreHorizIcon color={grey400} />
        </IconButton>
      );
      const rightIconMenu = (
        <IconMenu
          iconButtonElement={iconButtonElement}
          open={this.state.openIconMenu}
          useLayerForClickAway={true}
          onClick={() => this.setState({openIconMenu: true})}
          onRequestChange={() => this.setState({openIconMenu: false})}
        >
          <MenuItem onClick={this.onMenuItemClicked}>
            Remove from Group
          </MenuItem>
        </IconMenu>
      );

      if (this.props.member.role){
        role = this.props.member.role;
        secondaryText.push(<span key="role" style={{whiteSpace:'pre'}}>{role}</span>)
      }

      return (
        <div>
          <ListItem
            disabled={true}
            leftAvatar={
              <Avatar backgroundColor={this.props.color} src="">
                {this.props.member.displayName.substring(0, 1)}
              </Avatar>
            }
            rightIconButton={(this.props.roomType != "team_random" && this.props.roomType != "team_general") ? rightIconMenu : null}
            primaryText= {
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start'
                }}>
                {this.props.member.displayName}
              </div>
            }
            secondaryText={
              <div style={{
                flex:1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                fontSize: 14,
              }}>
                {secondaryText}
              </div>
            }
            secondaryTextLines={1}
          />
        </div>
      )
    }

}

function mapStateToProps(state, ownProps) {
   const roomId = ownProps.currentRoomId;
   let roomType = undefined;

   if (state.firebase.rooms.metadata[roomId]) {
     roomType = state.firebase.rooms.metadata[roomId].value.type;
   }

  return {
    roomType: roomType
  }
};

export default connect(mapStateToProps)(ChatMessageMemberListItem);



// WEBPACK FOOTER //
// ./src/chat/ChatMessageMemberListItem.js